import Model from "@/models/Model";
import {UserState} from "@/helpers/constants";

export default class UserBlamable extends Model {

	public state!: UserState;
	public firstname!: string;
	public lastname!: string;

	public static fullName(user: UserBlamable | null): string | null {
		if (user === null) return null;

		const parts = [] as string[];
		if (user.firstname !== null && user.firstname.length > 0) parts.push(user.firstname);
		if (user.lastname !== null && user.lastname.length > 0) parts.push(user.lastname);
		return parts.length > 0 ? parts.join(' ') : null;
	}

}
